var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPracticeTestBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 220,
    viewBox: "0 0 445 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 220,
    rx: 32,
    fill: "url(#paint0_linear_1039_1357)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M443.204 109.546C440.107 107.755 437.863 107.706 436.473 109.401C435.082 111.071 434.399 113.903 434.399 117.897V139.417C434.399 143.508 434.009 146.897 433.253 149.584C432.497 152.368 431.204 154.353 429.424 155.515C427.692 156.701 425.351 157.016 422.375 156.459C419.473 155.927 415.838 154.426 411.497 151.932L409.424 150.746V133.801L412.009 135.278C415.107 137.069 417.18 137.287 418.229 135.98C419.326 134.721 419.887 132.083 419.887 128.089V109.134C419.887 104.196 420.375 100.299 421.351 97.4182C422.326 94.5375 424.253 92.722 427.156 91.8989C424.253 87.7595 422.326 83.717 421.351 79.747C420.375 75.777 419.912 71.3229 419.912 66.3847V47.4306C419.912 43.4364 419.351 40.1926 418.253 37.6509C417.229 35.1576 415.156 33.0274 412.034 31.236L409.448 29.7594V12.8145L411.521 14.0006C415.863 16.4939 419.497 19.1325 422.399 21.9405C425.375 24.7727 427.716 27.7986 429.448 30.9698C431.253 34.1893 432.521 37.6267 433.277 41.282C434.034 44.8404 434.424 48.6893 434.424 52.7561V74.2762C434.424 78.2704 435.107 81.9014 436.497 85.1452C437.887 88.4131 440.131 90.9307 443.229 92.6978L443.204 109.546Z",
    fill: "url(#paint1_linear_1039_1357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M364.546 47.2128C367.643 49.0041 369.887 49.0525 371.278 47.358C372.668 45.6877 373.351 42.8555 373.351 38.8613V17.3413C373.351 13.2503 373.741 9.86127 374.497 7.17428C375.253 4.39047 376.497 2.38128 378.229 1.19514C380.034 0.0331982 382.375 -0.281494 385.278 0.251062C388.253 0.807824 391.912 2.33287 396.253 4.8262L398.326 6.01234V22.9573L395.741 21.4807C392.643 19.6893 390.521 19.4473 389.424 20.706C388.4 22.0132 387.863 24.6518 387.863 28.646V47.6001C387.863 52.5383 387.375 56.4357 386.4 59.3163C385.424 62.1727 383.497 64.0125 380.595 64.8355C383.497 68.9749 385.424 73.0175 386.4 76.9875C387.375 80.9574 387.839 85.4115 387.839 90.3498V109.304C387.839 113.298 388.351 116.542 389.4 119.035C390.497 121.577 392.619 123.731 395.717 125.498L398.302 126.975V143.92L396.229 142.734C391.887 140.241 388.229 137.578 385.253 134.746C382.351 131.938 380.009 128.936 378.204 125.716C376.473 122.545 375.229 119.132 374.473 115.453C373.717 111.894 373.326 108.045 373.326 103.978V82.4583C373.326 78.4641 372.643 74.833 371.253 71.5893C369.863 68.3214 367.619 65.8038 364.521 64.0367L364.546 47.2128Z",
    fill: "url(#paint2_linear_1039_1357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M433.448 116.808C430.351 115.016 428.107 114.968 426.717 116.662C425.327 118.333 424.644 121.165 424.644 125.159V146.679C424.644 150.77 424.253 154.159 423.497 156.846C422.741 159.63 421.448 161.615 419.668 162.777C417.936 163.963 415.595 164.278 412.619 163.721C409.717 163.188 406.083 161.688 401.741 159.194L399.668 158.008V141.063L402.253 142.54C405.351 144.331 407.424 144.549 408.473 143.242C409.57 141.983 410.131 139.344 410.131 135.35V116.396C410.131 111.458 410.619 107.561 411.595 104.68C412.57 101.799 414.497 99.9837 417.4 99.1607C414.497 95.0213 412.57 90.9787 411.595 87.0087C410.619 83.0388 410.156 78.5847 410.156 73.6464V54.6923C410.156 50.6981 409.595 47.4544 408.497 44.9126C407.473 42.4193 405.4 40.2891 402.278 38.4977L399.692 37.0211V20.0762L401.766 21.2623C406.107 23.7556 409.741 26.3942 412.644 29.2022C415.619 32.0345 417.961 35.0603 419.692 38.2315C421.497 41.451 422.766 44.8884 423.522 48.5437C424.278 52.1021 424.668 55.951 424.668 60.0178V81.5379C424.668 85.5321 425.351 89.1631 426.741 92.4069C428.131 95.6749 430.375 98.1924 433.473 99.9595L433.448 116.808Z",
    fill: "url(#paint3_linear_1039_1357)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M354.789 54.4745C357.887 56.2658 360.131 56.3142 361.521 54.6197C362.911 52.9495 363.594 50.1172 363.594 46.1231V24.603C363.594 20.512 363.984 17.123 364.74 14.436C365.496 11.6522 366.74 9.643 368.472 8.45686C370.277 7.29492 372.618 6.98022 375.521 7.51278C378.496 8.06954 382.155 9.59459 386.496 12.0879L388.57 13.2741V30.219L385.984 28.7424C382.887 26.9511 380.765 26.709 379.667 27.9678C378.643 29.2749 378.106 31.9135 378.106 35.9077V54.8618C378.106 59.8001 377.618 63.6974 376.643 66.578C375.667 69.4345 373.74 71.2742 370.838 72.0972C373.74 76.2366 375.667 80.2792 376.643 84.2492C377.618 88.2192 378.082 92.6733 378.082 97.6115V116.566C378.082 120.56 378.594 123.804 379.643 126.297C380.74 128.839 382.862 130.993 385.96 132.76L388.545 134.237V151.182L386.472 149.996C382.131 147.502 378.472 144.839 375.496 142.007C372.594 139.199 370.252 136.198 368.448 132.978C366.716 129.807 365.472 126.394 364.716 122.714C363.96 119.156 363.57 115.307 363.57 111.24V89.72C363.57 85.7258 362.887 82.0948 361.496 78.851C360.106 75.5831 357.862 73.0655 354.765 71.2984L354.789 54.4745Z",
    fill: "url(#paint4_linear_1039_1357)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M300.644 2.96191L342.326 26.8543L342.302 125.934L300.619 102.041L300.644 2.96191Z",
    fill: "url(#paint5_linear_1039_1357)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.813 18.1885L325.96 37.191V46.3171L292.813 27.3145V18.1885Z",
    fill: "#F2C94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M305.79 57.791L337.644 76.0431V90.2285L305.79 71.9764V57.791Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M305.766 40.6289L337.668 58.9052V62.1974L305.766 43.9453V40.6289Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M305.766 47.0674L333.351 62.8746V66.1668L305.766 50.3595V47.0674Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.644 2.96191L342.326 26.8543V40.144L300.644 16.2516V2.96191Z",
    fill: "url(#paint6_linear_1039_1357)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.058 15.6465C311.058 17.6557 309.863 18.5998 308.4 17.7767C306.936 16.9295 305.766 14.6298 305.766 12.6206C305.766 10.6114 306.961 9.66736 308.424 10.4904C309.863 11.3377 311.058 13.6373 311.058 15.6465Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M351.862 94.8281L393.545 118.72L393.521 217.8L351.838 193.908L351.862 94.8281Z",
    fill: "url(#paint7_linear_1039_1357)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M367.741 123.659L400.888 142.638V151.739L367.717 132.761L367.741 123.659Z",
    fill: "#F2994A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M357.009 133.075L388.887 151.352V165.513L357.009 147.236V133.075Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M356.96 153.312L388.862 171.589V174.881L356.96 156.629V153.312Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M356.96 159.268L384.545 175.075V178.367L356.96 162.56V159.268Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M351.862 94.8281L393.545 118.721V132.01L351.862 108.118V94.8281Z",
    fill: "url(#paint8_linear_1039_1357)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M362.277 107.537C362.277 109.546 361.082 110.49 359.619 109.667C358.155 108.82 356.984 106.52 356.984 104.511C356.984 102.502 358.179 101.558 359.643 102.381C361.082 103.204 362.277 105.528 362.277 107.537Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M344.643 108.554L272.082 66.9902L272.106 104.535L338.277 142.444L344.692 151.86L344.643 108.554Z",
    fill: "url(#paint9_linear_1039_1357)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M325.984 107.004L310.082 97.9023V101.195L325.984 110.296V107.004Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M325.985 113.613L286.619 91.0518V94.3439L326.009 116.905L325.985 113.613Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M326.009 120.221L278.473 92.9883V96.2804L326.009 123.513V120.221Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M329.911 112.693C329.911 115.791 331.765 119.35 334.033 120.657C336.301 121.964 338.155 120.512 338.155 117.413C338.155 114.315 336.301 110.756 334.033 109.449C331.74 108.142 329.911 109.594 329.911 112.693Z",
    fill: "#F2994A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M279.253 40.6284L269.644 35.1092V31.8896L279.253 37.4089C280.034 37.8688 281.18 38.7645 282.156 40.1685C283.205 41.6693 283.961 43.5575 283.961 45.6151C283.961 47.8905 283.375 49.1735 282.278 49.5608C281.229 49.8997 280.009 49.3187 279.253 48.883L275.302 46.6075L275.278 46.5833C274.936 46.3897 274.4 46.196 273.985 46.3171C273.644 46.4139 273.229 46.777 273.229 48.0358C273.229 49.2945 273.619 50.0692 273.961 50.5291C274.375 51.1101 274.912 51.5216 275.253 51.691L275.302 51.7152L287.4 58.6385V61.858L275.375 54.959C274.546 54.5233 273.351 53.6276 272.326 52.1994C271.205 50.6259 270.424 48.6409 270.424 46.4139C270.424 44.211 271.205 43.0733 272.302 42.7586C273.326 42.4681 274.522 42.9039 275.351 43.388L279.278 45.6393C279.839 45.954 280.278 46.0992 280.546 46.0024C280.766 45.9297 281.156 45.6151 281.156 43.9932C281.156 42.9281 280.814 42.2503 280.473 41.7661C280.083 41.2336 279.57 40.7979 279.253 40.6284Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.497 35.4485C272.497 38.2081 270.863 39.4911 268.863 38.3534C266.863 37.2156 265.229 34.0445 265.229 31.2849C265.229 28.5253 266.863 27.2423 268.863 28.3801C270.863 29.542 272.497 32.7131 272.497 35.4485Z",
    fill: "#F2C94C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.765 62.0755C291.765 64.8351 290.131 66.118 288.131 64.9803C286.131 63.8426 284.497 60.6715 284.497 57.9119C284.497 55.1522 286.131 53.8693 288.131 55.007C290.131 56.1689 291.765 59.3401 291.765 62.0755Z",
    fill: "#F2C94C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M317.692 146.244C319.156 147.091 320.326 149.1 320.326 150.795V158.178L325.253 160.986C326.717 161.833 327.887 163.842 327.887 165.537C327.887 167.207 326.692 167.885 325.253 167.062L320.326 164.254V171.637C320.326 173.307 319.131 173.985 317.692 173.162C316.229 172.315 315.058 170.306 315.058 168.611V161.228L310.131 158.42C308.668 157.573 307.497 155.563 307.497 153.869C307.497 152.199 308.692 151.521 310.131 152.344L315.058 155.152V147.769C315.058 146.074 316.229 145.396 317.692 146.244Z",
    fill: "url(#paint10_linear_1039_1357)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.5233 151.954C25.9898 147.962 22.4841 147.437 22.3368 147.408C21.9833 147.35 21.7771 147.67 21.7771 148.137V158.686C21.7771 162.271 20.5398 164.573 18.0946 165.564C17.859 165.651 17.7117 165.913 17.7117 166.263C17.7117 171.334 17.8 193.103 17.8295 199.893C17.8295 201.03 18.6249 202.37 19.5971 202.924C24.8114 205.926 39.8653 214.522 39.8653 214.522C43.8718 216.825 46.4347 215.397 46.8766 210.676L46.9355 189.781C46.9355 186.604 46.3758 183.34 44.6082 180.63C43.6066 179.086 42.4282 177.891 41.1909 177.191L30.9095 171.334V161.542C30.939 157.695 30.1141 154.49 28.5233 151.954Z",
    fill: "url(#paint11_linear_1039_1357)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42799 157.521L15.9404 164.05V201.081L4.42799 194.551V157.521Z",
    fill: "#F2C94C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M201.026 172.868L108.757 172.846L105.826 177.89L198.095 177.912L201.026 172.868Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M195.128 183.019L121.208 182.992L118.277 188.036L192.165 188.044L195.128 183.019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1039_1357",
    x1: 0,
    y1: 220,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#448FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1039_1357",
    x1: 458.549,
    y1: 17.7088,
    x2: 399.073,
    y2: 121.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1039_1357",
    x1: 429.625,
    y1: 0.698119,
    x2: 370.149,
    y2: 104.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1039_1357",
    x1: 448.793,
    y1: 24.9705,
    x2: 389.317,
    y2: 128.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1039_1357",
    x1: 419.869,
    y1: 7.95979,
    x2: 360.393,
    y2: 111.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1039_1357",
    x1: 343.083,
    y1: 27.2787,
    x2: 303.71,
    y2: 96.0086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1039_1357",
    x1: 314.945,
    y1: 3.16421,
    x2: 327.462,
    y2: 38.9234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1039_1357",
    x1: 394.3,
    y1: 119.151,
    x2: 354.927,
    y2: 187.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1039_1357",
    x1: 366.162,
    y1: 95.0365,
    x2: 378.679,
    y2: 130.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1039_1357",
    x1: 328.822,
    y1: 93.5289,
    x2: 291.561,
    y2: 122.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1039_1357",
    x1: 322.78,
    y1: 155.675,
    x2: 310.08,
    y2: 165.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1039_1357",
    x1: 21.4472,
    y1: 177.327,
    x2: 58.2589,
    y2: 191.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeTestBg);
export default __webpack_public_path__ + "static/media/practiceTestBg.373a53c13fb15aa6814eb5582f6371ca.svg";
export { ForwardRef as ReactComponent };